import emotionReact_isolatedHnrs from "@emotion/react/_isolated-hnrs";
import { createSlice } from "@reduxjs/toolkit";
import { isArray } from "lodash";
const stateSlice = createSlice({
  name: "productionPlanningList/state",
  initialState: {
    deleteConfirmation: false,
    selectedpro: "",
    selectedprod: {},
    selectedproduction: [],
    selectedEditProduction: {},
    newDialog: false,
    editDialog: false,
  },
  reducers: {
    toggleDeleteConfirmation: (state, action) => {
      state.deleteConfirmation = action.payload;
    },
    setSelectedProduction: (state, action) => {
      state.selectedEditProduction = action.payload;
    },
    setSelectedprod: (state, action) => {
      state.selectedprod = action.payload;
    },

    addSelectedProduction: (state, action) => {
      const arr = action?.payload?.Worker.map((item) => ({
        ...action?.payload,
        Worker: { worker_name: item.worker_name, worker_id: item.worker_id },
        quantity:
          parseFloat(action?.payload?.quantity) /
          action?.payload?.Worker.length,
      }));

      state.selectedproduction = [...state.selectedproduction, ...arr];
    },
    updateSelectedProduction: (state, action) => {
      const index = state.selectedproduction.findIndex(
        (item) =>
          item?.Worker?.worker_id === action.payload?.Worker[0].worker_id
      );
      console.log(index);
      state.selectedproduction[index] = {
        ...action.payload,
        Worker: {
          worker_name: action.payload.Worker[0].worker_name,
          worker_id: action.payload.Worker[0].worker_id,
        },
      };
      state.selectedEditProduction = {};
    },
    toggleNewDialog: (state, action) => {
      state.newDialog = action.payload;
    },
    deleteSelectedProduction: (state, action) => {
      state.selectedproduction = state.selectedproduction.filter(
        (item, index) => index !== action.payload
      );
    },
    emptySelectedProduction: (state, action) => {
      state.selectedproduction = action.payload;
    },
    toggleNewEditDialog: (state, action) => {
      state.editDialog = action.payload;
    },
    addProDetail: (state, action) => {
      //  state.selectedproduction=[];
      state.selectedproduction = [...action.payload];
    },
  },
});

export const {
  toggleDeleteConfirmation,
  setSelectedProduction,
  setSelectedprod,
  toggleNewDialog,
  addProDetail,
  addSelectedProduction,
  updateSelectedProduction,
  deleteSelectedProduction,
  emptySelectedProduction,
  toggleNewEditDialog,
} = stateSlice.actions;

export default stateSlice.reducer;
